import { useMutation } from '@tanstack/react-query';

import OffersService from '~/services/OffersService';

export function usePopulateFromProperty() {
  return useMutation({
    mutationFn: (offers: Array<{ offerIdSalesforceExternal: string; propertyId: string }>) =>
      OffersService.populateFromPropertyBulk(offers),
  });
}
